import { createContext, useContext } from 'react';
var FieldsetContext = /*#__PURE__*/createContext(null);
export var FieldsetContextProvider = FieldsetContext.Provider;
export var useFieldset = function useFieldset() {
  var context = useContext(FieldsetContext);
  return context;
};